// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1BvMB","list":"styles_list__1Bhvm"};